import React from "react";
import { useSelector } from "react-redux";
import { selectReceipt } from "../../../redux/slices/receiptSlice";
import { selectIsCms } from "../../../redux/slices/configSlice";
import AddToCalendarControl from "./AddToCalendarControl";

/**
 * @param {object} props
 * @param {string} props.controlId
 * @returns {React.ReactElement|null}
 */
const ConnectedAddToCalendarControl = ({ controlId }) => {
    const isCms = useSelector(selectIsCms);
    const receipt = useSelector(selectReceipt);
    const { transaction = {} } = receipt;
    const { calendarData = {} } = transaction;
    const { e_date_begin = "" } = calendarData;

    const displayAddToCalendar = isCms || !!e_date_begin;

    return displayAddToCalendar ? (
        <AddToCalendarControl controlId={controlId} />
    ) : null;
};

export default ConnectedAddToCalendarControl;
